"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
const Editor_1 = __importDefault(require("./Editor"));
exports.Editor = Editor_1.default;
exports.default = Editor_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9FZGl0b3IvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLCtCQUErQjs7Ozs7O0FBRS9CLHNEQUE2QjtBQUVwQixpQkFGRixnQkFBTSxDQUVFO0FBQ2Ysa0JBQWUsZ0JBQU0sQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCDCqSAyMDIxIE1vdmUgQ2xvc2VyXG5cbmltcG9ydCBFZGl0b3IgZnJvbSAnLi9FZGl0b3InXG5cbmV4cG9ydCB7IEVkaXRvciB9XG5leHBvcnQgZGVmYXVsdCBFZGl0b3JcbiJdfQ==